module.exports = __webpack_public_path__ + "static/media/ls.0ed298ed.svg";